import { useTypedFlags } from "@hooks/useTypedFlags";
import { SimilarTransactionsUpdateDrawerLegacy } from "./SimilarTransactionsUpdateDrawerLegacy";
import { SimilarTransactionsUpdateDrawerNext } from "./SimilarTransactionsUpdateDrawerNext";

export const SimilarTransactionsUpdateDrawer: React.FC = () => {
    const { enableSimilarityRules } = useTypedFlags();

    return enableSimilarityRules ? (
        <SimilarTransactionsUpdateDrawerNext />
    ) : (
        <SimilarTransactionsUpdateDrawerLegacy />
    );
};
